import PageEmptyState from 'common/components/PageEmptyState';
import React from 'react';

const Messages = () => {
  return <PageEmptyState />;
};

export default Messages;
